import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Indicator from "../components/signup-steps/Indicator";
import Step2 from "../components/signup-steps/Step2";
import Step5 from "../components/signup-steps/Step5";
import Step6 from "../components/signup-steps/Step6";
import { getImageBaseUrl } from "../services/s3-utils";
import { useEffect } from "react";
import { updateUserInterests } from "../services/UserService";
import { GetUser } from "../services/NewAuthService";
import { useDispatch, useSelector } from "react-redux";
import { updateUserInformation } from "../services/NewAuthService";
import { updateUserSlice } from "../store/slices/userSlice";
import notification from "antd/lib/notification";
import { updateUserData } from "../store/slices/updateUserData";
import AvatarBio from "../components/signup-steps/AvatarBio";
import SEO from "../components/Seo";
import QalortButton from "../components/Button";

function CompleteSignup(props) {
  const qalortUser = useSelector((state) => state.user.userData);
  const storedData = useSelector((state) => state.updateData.updateData);
  const [currStep, setCurrStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [payload, updatePayload] = useState(
    storedData || {
      biography: qalortUser.biography,
      categories: [],
      country_code: "",
      country: qalortUser.country,
      cover: qalortUser.cover,
      facebook: qalortUser.social.facebook,
      first_name: qalortUser.first_name,
      gender: "",
      github_link: "",
      instagram: "",
      language: [],
      last_name: qalortUser.last_name,
      linkedin: qalortUser.social.linkedin_link,
      medium_id: "",
      phone: qalortUser.phone,
      profile: qalortUser.profile,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      twitter: qalortUser.social.twitter,
    }
  );
  const [selectedCategories, setSelectedCategories] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user_type = qalortUser?.user_type;
  let stepsCount = [1, 2, 3, 4];
  const filledClass = `w-${currStep}/${stepsCount.length}`;
  const steps = {
    1: {
      title: "Welcome!",
      subtitle: "Help us make your Qalort experience more personal.",
    },
    2: {
      title: "Tell Us More About You 😃",
      subtitle: "",
    },
    3: {
      title: "We want to know what you do & where to find you.",
      subtitle: ``,
    },
    4: {
      title: "Yay The Final Step! 😃",
      subtitle:
        "After this, you get to be part of our community. Now pick the fields you’re interested in.",
    },
    5: {
      title: "Tell Us More About Yourself 😃",
      subtitle: "",
    },
    6: {
      title: "We want to know what you do & where to find you.",
      subtitle: ``,
    },
  };

  const setPayload = (data) => {
    const updatePayloadData = {
      ...payload,
      ...data,
    };

    updatePayload(updatePayloadData);
    dispatch(updateUserData(updatePayloadData));
  };

  const updateUserProfile = async () => {
    const data = {
      ...payload,
      first_name: qalortUser?.first_name,
      last_name: qalortUser?.last_name,
      email: qalortUser?.email,
      categories: selectedCategories,
      social: {
        linkedin: payload.linkedin,
        twitter: payload.twitter,
        facebook: payload.facebook,
        medium: payload.medium,
      },
    };
    setLoading(true);
    try {
      await updateUserInformation(data);
      dispatch(updateUserData(null));
      fetchUser();
    } catch (error) {
      notification.error({
        message: error.response?.data?.message || "An error occured",
      });
    } finally {
      setLoading(false);
    }
  };

  const updateInterests = async () => {
    try {
      await updateUserInterests(
        selectedCategories.map((itm) => {
          return {
            category_id: itm,
            sub_category_id: null,
            topic_id: null,
          };
        })
      );
    } catch (error) {}
  };

  useEffect(() => {
    if (!qalortUser) {
      navigate("/");
    }
  }, []);

  const fetchUser = async () => {
    const res = await GetUser();
    const payload = {
      ...qalortUser,
      ...res.data.data,
      full_name: `${res.data.data.first_name} ${res.data.data.last_name}`,
    };
    dispatch(updateUserSlice(payload));
    navigate("/dashboard");
  };

  useEffect(() => {
    if (qalortUser) {
      setPayload({
        biography: qalortUser.biography,
        categories: [],
        country_code: "",
        country: qalortUser.country,
        cover: qalortUser.cover,
        facebook: qalortUser.social.facebook,
        first_name: qalortUser.first_name,
        gender: "",
        github_link: "",
        instagram: "",
        language: [],
        last_name: qalortUser.last_name,
        linkedin: qalortUser.social.linkedin_link,
        medium_id: "",
        phone: qalortUser.phone,
        profile: qalortUser.profile,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        twitter: qalortUser.social.twitter,
      });
      setSelectedCategories(
        qalortUser?.interests?.map((c) => c.category_id) || []
      );
    }
  }, [qalortUser]);

  return (
    <>
      <SEO />
      <div className="flex [@media(min-width:987px)]:p-4 h-screen overflow-hidden">
        <div className="w-[41%] h-full bg-pri-tint flex items-center justify-center relative [@media(max-width:986px)]:hidden">
          <Link to="/">
            <img
              src={`${getImageBaseUrl}/assets/logo.svg`}
              className="absolute top-8 left-8"
              alt=""
            />
          </Link>
          <img
            src={`${getImageBaseUrl}/assets/auth.png`}
            className="w-2/3"
            alt=""
          />
        </div>

        <div className="flex-1 px-5 [@media(max-width:986px)]:pt-4 [@media(min-width:1200px)]:px-20 pt-[92px] [@media(min-width:1330px)]:pl-[146px] [@media(min-width:1330px)]:pr-[135px] h-full overflow-auto mb-20">
          <Link
            to="/"
            className="hidden [@media(max-width:986px)]:flex border-b border-neutral py-4 mb-[34px] pl-5 pr-5 -ml-5 -mr-5"
          >
            <img
              src={`${getImageBaseUrl}/assets/logo.svg`}
              className="h-8 w-[103px]"
              alt=""
            />
          </Link>
          <div>
            <Link
              to={"/dashboard"}
              className="flex items-center justify-end mb-8"
            >
              <button className="text-[#535393]">Skip Setting Up </button>
              <button className="border-pri text-[#5f5ffa] border bg-[#F9F9FF] p-2 h-[40px] rounded-[6px] ml-2">
                <span className="!text-[14px]">Go to Dashboard</span>
              </button>
            </Link>
          </div>
          <Indicator
            currStep={currStep}
            stepsCount={stepsCount}
            filledClass={filledClass}
          />

          <h1 className="text-4xl [@media(max-width:600px)]:text-2xl font-semibold text-dark mb-0">
            {steps[currStep].title}
          </h1>
          <h3 className="[@media(max-width:600px)]:mb-8 mt-3.5 sm:mt-[18px] mb-10 text-sm text-tint font-light">
            {steps[currStep].subtitle}
          </h3>

          {currStep === 1 && (
            <Step2
              setPayload={setPayload}
              currStep={currStep}
              setCurrStep={setCurrStep}
              payload={payload}
            />
          )}

          {currStep === 2 && (
            <AvatarBio
              currStep={currStep}
              setCurrStep={setCurrStep}
              setPayload={setPayload}
              payload={payload}
              isNew
            />
          )}

          {currStep === 3 && (
            <Step5
              setPayload={setPayload}
              currStep={currStep}
              setCurrStep={setCurrStep}
              user_type={user_type}
              payload={payload}
            />
          )}

          {currStep === 4 && (
            <Step6
              setPayload={setPayload}
              currStep={currStep}
              setCurrStep={setCurrStep}
              setSelectedCategories={setSelectedCategories}
              selectedCategories={selectedCategories}
              loading={loading}
              finishReg={() => {
                updateUserProfile();
                updateInterests();
              }}
              payload={payload}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default CompleteSignup;
